import React from "react";
import { Link } from "react-router-dom";

const AboutPage = () => {
  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <section className="bg-[#fe7590] text-white py-20">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">Our Story</h1>
          <p className="text-lg">
            Pioneering quality and style . We're more than a
            store, we're a community.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold mb-4">Our Mission</h2>
          <p className="text-gray-700">
            At Pure Clean Shopping, our mission is to provide exceptional
            products that enrich the lives of our customers. We are dedicated to
            sourcing the highest quality materials, championing ethical
            production, and delivering an unparalleled shopping experience from
            start to finish.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-semibold mb-4">How It All Began</h2>
            <p className="text-gray-700 mb-2">
              It all started in a small garage with a big idea: to create
              products that were not only beautiful and functional but also made
              a positive impact. Our founder, was frustrated
              with the lack of options that combined modern design with
              sustainable practices.
            </p>
            <p className="text-gray-700">
              From those humble beginnings, we've grown into a team of
              passionate creators, designers, and dreamers, all united by a
              single goal: to bring you the very best. Every product in our
              catalog is a testament to our journey and our unwavering
              commitment to quality.
            </p>
          </div>
          <div>
            <img
              src="/assests/banners/about.jpg"
              alt="Our workshop"
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold mb-8">Meet The Team</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: "[Founder's Name]",
                role: "Founder & CEO",
                desc: "Visionary and coffee enthusiast. Drives the company's mission and strategic direction.",
                // img: "https://i.pravatar.cc/150?img=32",
              },
              {
                name: "[Team Member Name]",
                role: "Head of Product",
                desc: "Obsessed with quality and design. Ensures every product meets our high standards.",
                // img: "https://i.pravatar.cc/150?img=47",
              },
              {
                name: "[Team Member Name]",
                role: "Customer Happiness Lead",
                desc: "Your go-to person for all things support. Committed to making every customer smile.",
                // img: "https://i.pravatar.cc/150?img=33",
              },
            ].map((member, i) => (
              <div key={i} className="bg-white rounded-lg shadow-lg p-6">
                {/* <h3 className="text-xl font-semibold">{member.name}</h3> */}
                <p className="text-[#fe7590] mb-2">{member.role}</p>
                <p className="text-gray-700">{member.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold mb-8">Our Values</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              {
                title: "🌱 Sustainability",
                desc: "We prioritize eco-friendly materials and processes to protect our planet.",
              },
              {
                title: "🤝 Community",
                desc: "We believe in building strong relationships with our customers, partners, and each other.",
              },
              {
                title: "✨ Quality",
                desc: "From design to delivery, quality is at the heart of everything we do.",
              },
              {
                title: "🚀 Innovation",
                desc: "We are always exploring new ideas and technologies to better serve you.",
              },
            ].map((value, i) => (
              <div key={i} className="bg-gray-50 p-6 rounded-lg shadow">
                <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
                <p className="text-gray-700">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-16 bg-[#fe7590] text-white text-center">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-semibold mb-4">Join Our Journey</h2>
          <p className="mb-6">
            Be the first to know about new products, exclusive offers, and our
            story.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-indigo-600 font-semibold px-6 py-3 rounded-full hover:bg-gray-100 transition"
          >
            Get In Touch
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
